import { render, staticRenderFns } from "./setRole.vue?vue&type=template&id=15a9c151&scoped=true"
import script from "./setRole.vue?vue&type=script&lang=js"
export * from "./setRole.vue?vue&type=script&lang=js"
import style0 from "./setRole.vue?vue&type=style&index=0&id=15a9c151&prod&lang=css"
import style1 from "./setRole.vue?vue&type=style&index=1&id=15a9c151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a9c151",
  null
  
)

export default component.exports